<template lang="pug">
  .sud-card-headline
    slot
</template>

<script>
export default {
  name: 'app-card-headline'
}
</script>

<style scoped>
.sud-card-headline {
  padding-bottom: 24px;
  margin-bottom: 32px;

  font-family: "Roboto Slab";
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 18px;

  color: #757575;
  border-bottom: 1px solid #C4C4C4;

  word-wrap: break-word;
  word-break: break-all;
}
</style>
